import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';
import { Observable } from 'rxjs';
import { I18nTranslator } from '../../../../i18n/translate';
import { ARColzaOrder, ARColzaOrderItem } from '../../../../models/agrorendement-colza.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { ARColzaService } from '../../../../services/agrorendement-colza.service';
import { ParcelService } from '../../../../services/parcel.service';
import { PreventDoubleClickDirective } from '../../../../utils/preventDoubleClick';
import { AROrderEditComponent } from '../common/order-edit.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-colza-order-edit',
  templateUrl: '../common/order-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, PreventDoubleClickDirective, CampaignYearPipe, CapitalizePipe, HectareConverterPipe, TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
  providers: [ARColzaService, ParcelService],
})
export class ARColzaOrderEditComponent
  extends AROrderEditComponent<ARColzaOrder, ARColzaOrderItem>
  implements OnInit, OnDestroy
{
  @Input() orderItem: ARColzaOrderItem;

  constructor(
    protected service: ARColzaService,
    protected parcelService: ParcelService,
    protected i18nTranslator: I18nTranslator,
    protected modal: ModalService,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.colza.section');
    this.specyUrlPart = ['azote', 'colza'];
    this.specyIconClass = 'fa-bullseye';
    this.specyOrderCode = 'ORDC';
    this.routeActionIndex = 4;
    this.toolStatusCode = 'ARColza';
  }

  buildNew(): ARColzaOrder {
    return new ARColzaOrder();
  }

  remoteGetOrderItems(orderItemIds: Array<number>): Observable<ARColzaOrderItem[]> {
    // pas encore commandé (false) + completion pas d'importance
    return this.service.getOrderItems(orderItemIds, null, false);
  }

  remoteGetOrderItem(orderItemId: number): Observable<ARColzaOrderItem> {
    return this.service.getOrderItem(orderItemId);
  }
}
